// extracted by mini-css-extract-plugin
export default {"container":"Select_container__pmWug","label":"Select_label__OvD4i"};